class CartUpsellItem extends HTMLElement{
  constructor(){
    super()

    this.swatches = this.querySelectorAll('.color-swatch')
    this.form = this.querySelector('form')
    this.colorLabel = this.querySelector('.color-swatch-title')
    this.variantsData = JSON.parse(this.getAttribute('data-variants-data'));
    this.numOptions = this.getAttribute('data-num-options');
    this.option2Select = this.querySelector('.js-cart-size-select');

    this.init()

    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.handleClick.bind(this))
    })
    
    if (this.option2Select) {
      this.option2Select.addEventListener('change', this.handleOptionChange.bind(this))
    }
  }

  init(){
    if(this.numOptions == 1){
        Object.entries(this.variantsData).forEach(([variantId, variant]) => {
            if(!variant.available){
                this.querySelector(`.color-swatch[data-id="${variantId}"]`)?.remove();
            }
        })

        this.swatches = this.querySelectorAll('.color-swatch');
    }

    if (!this.swatches.length) return

    this.swatches[0].setAttribute('id', 'active-border');
    this.colorLabel && (this.colorLabel.textContent = this.swatches[0].getAttribute('data-text'));

    if (parseInt(this.numOptions) > 1) {
      this.updateSizeOptions(this.getActiveColorValue())
    }

    this.syncSelectedVariant()

    this.swatches.forEach((swatch, index) => {
        index > 3 && swatch.classList.add("hidden")
    })

    if(this.swatches.length > 4){
        let newPlus = document.createElement('div');
        newPlus.classList.add('label-selector-extra');
        newPlus.classList.add('color-swatch-plus');
        newPlus.textContent = '+' + (this.swatches.length - 4);
        newPlus.style.fontSize = '1.5rem';
        newPlus.style.fontWeight = '500';
        newPlus.style.marginTop = '0!important';
        newPlus.style.marginLeft = '0.5rem';
        this.querySelector('.label-selector-extra')?.appendChild(newPlus)

        let newRow = document.createElement('img');
        newRow.src = 'https://cdn.shopify.com/s/files/1/0421/8480/2468/files/Arrow-left.svg?v=1715241179';
        newRow.style.width = '100%';
        newRow.style.maxWidth = '3rem';
        newRow.style.marginRight = '0.5rem';

        newPlus.addEventListener('click', () => {
            for (let i = 4; i < this.swatches.length; i++) {
              this.swatches[i].classList.remove("hidden");
              newRow.style.display = 'block';
              newRow.style.cursor = 'pointer';
              this.querySelector('.label-selector-extra')?.prepend(newRow);
            }

            for (let i = 0; i <= 3; i++) {
              this.swatches[i].classList.add('hidden');
            }
            newPlus.style.display = 'none';
          });

          newRow.addEventListener('click', () => {
            for (let i = 4; i < this.swatches.length; i++) {
              this.swatches[i].classList.add("hidden");
              newRow.style.display = 'none';
              this.querySelector('.label-selector-extra')?.appendChild(newPlus);
            }

            for (let i = 0; i <= 3; i++) {
              this.swatches[i].classList.remove("hidden");
            }
            newPlus.style.display = 'flex';
          });
    }
  }

  getActiveColorValue(){
    const activeSwatch = Array.from(this.swatches).find(swatch => swatch.getAttribute('id') === "active-border") || this.swatches[0]
    return activeSwatch?.getAttribute('data-option-value') || activeSwatch?.getAttribute('name')?.split(' / ')[0] || null
  }

  getSelectedSizeValue(){
    if (!this.option2Select) return null
    const selectedOption = this.option2Select.options[this.option2Select.selectedIndex]
    return selectedOption?.getAttribute('data-option-value') || selectedOption?.value || null
  }

  isColorSizeAvailable(colorValue, sizeValue){
    return Object.values(this.variantsData).some((variant) => {
      if (!variant.available) return false
      const options = [variant.option1, variant.option2, variant.option3].filter((value) => value != null && value !== '')
      return options.includes(colorValue) && options.includes(sizeValue)
    })
  }

  updateSizeOptions(colorValue){
    if (!this.option2Select || !colorValue) return

    Array.from(this.option2Select.options).forEach((option) => {
      const sizeValue = option.getAttribute('data-option-value') || option.value
      const available = this.isColorSizeAvailable(colorValue, sizeValue)
      option.hidden = !available
      option.disabled = !available
    })

    const selected = this.option2Select.options[this.option2Select.selectedIndex]
    if (!selected || selected.hidden || selected.disabled) {
      const firstAvailable = Array.from(this.option2Select.options).find((option) => !option.hidden && !option.disabled)
      if (firstAvailable) {
        this.option2Select.value = firstAvailable.value
      }
    }
  }

  findMatchingVariantId(colorValue, sizeValue){
    const match = Object.entries(this.variantsData).find(([, variant]) => {
      if (sizeValue) {
        return variant.option1 === colorValue && variant.option2 === sizeValue
      }
      return variant.option1 === colorValue
    })
    return match ? match[0] : null
  }

  syncSelectedVariant(){
    const colorValue = this.getActiveColorValue()
    if (!colorValue) return

    const sizeValue = parseInt(this.numOptions) > 1 ? this.getSelectedSizeValue() : null
    const selectedVariant = this.findMatchingVariantId(colorValue, sizeValue)
    if (!selectedVariant) return

    const variant = this.variantsData[selectedVariant]
    const buyButton = this.querySelector('.buy-button-extra')
    if (buyButton) {
      if (!variant?.available) {
        buyButton.classList.add('disabled')
        buyButton.setAttribute('disabled', 'disabled')
      } else {
        buyButton.classList.remove('disabled')
        buyButton.removeAttribute('disabled')
      }
    }

    const variantInput = this.form?.querySelector('.product-variant-id')
    if (variantInput) variantInput.value = selectedVariant
    this.handleImageChange(selectedVariant)
  }

  handleClick(event){
    this.swatches.forEach(swatch => {
        swatch.removeAttribute('id');
    })
    event.target.setAttribute('id', 'active-border');
    this.colorLabel && (this.colorLabel.textContent = event.target.getAttribute('data-text'));

    if(parseInt(this.numOptions) == 1){
        let inputValue = event.target.previousElementSibling?.value || event.target.getAttribute('data-id');
        event.target.setAttribute('value', inputValue);
        if (this.form?.querySelector('.product-variant-id')) {
          this.form.querySelector('.product-variant-id').value = inputValue;
        }
        this.handleImageChange(inputValue)
    }else{
        const option1 = event.target.getAttribute('data-option-value')
        this.updateSizeOptions(option1)
        this.syncSelectedVariant()
    }
  }

  handleImageChange(variantId){
    const images = this.querySelectorAll('.img-cart')
    images.forEach(image => {
      if(image.getAttribute('data-variant-id') == variantId){
        image.style.display = 'block'
      }else{
        image.style.display = 'none'
      }
    })
  }

  handleOptionChange() {
    this.syncSelectedVariant()
  }
}

customElements.define('cart-upsell-item', CartUpsellItem)
